import { tss } from "tss-react/mui";
import { backgroundColor, boxShadow, panelHeaderHeight, panelHeaderColor } from "./common";
import { BorderTop } from "@mui/icons-material";
import { alpha } from '@mui/material/styles';

var useStyles = tss.create(({theme}) => ({
    leftRoot: {
        position: "absolute",
        display: "flex",
        flexDirection: "column",
        width: 300,
        height: panelHeaderHeight,
        userSelect: "none",
    },
    header: {
        display: "inline-flex",
        width: 300,
        height: panelHeaderHeight,
        cursor: "pointer",
        boxShadow: theme.shadows[3],
        //backgroundColor: panelHeaderColor,
        alignItems: "center",
        color: theme.palette.text.primary,
        background: theme.palette.background.default,
        borderTopWidth: "1px",
        borderTopStyle: 'solid',
        borderTopColor: theme.palette.divider,
    },
    title: {
        height: "100%",
        maxWidth: 130,
        paddingLeft: 0,
        paddingTop: 12,
    },
    content: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        width: "100%",
        minHeight: "calc(100vh - 100px)",
        transition: "height 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms, width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
        color: theme.palette.text.primary,
        background: alpha(theme.palette.background.default, 0.85)
    },
    layers: {
        display: "flex",
        flexDirection: "column",
        minHeight: "35vh",
        position: "relative",
        top: 1,
    },
    properties: {
        paddingLeft: 12,
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column",
        flexGrow: 0.6,
    },
    addObject: {
        height: 40,
        display: "flex",
        alignItems: "center",
        width: "100%",
        boxShadow: boxShadow,
        backgroundColor: theme.palette.primary.main,
        marginBottom: -1,
        zIndex: 10,
        color: theme.palette.text.primary
    },
    divider: {
        height: 2,
        backgroundColor: "rgb(0 0 0 / 10%)",
    },
    right: {
        position: "absolute",
        right: 0,
        height: panelHeaderHeight,
    },
    relative: {
        position: "relative",
    },
}));
export default useStyles;
